import type { Locale } from "@/lib/i18n/locale";

type BlogSeoLocaleOverride = {
	title: string;
	description: string;
	summary: string;
	keyPoints: string[];
	faq: { question: string; answer: string }[];
};

type BlogSeoOverride = Record<Locale, BlogSeoLocaleOverride>;

/** Optional per-article SEO copy (title, description, takeaways, FAQ), keyed by slug. */
const blogSeoOverrides: Record<string, BlogSeoOverride> = {};

export const getBlogSeoOverride = (slug: string, locale: Locale) =>
	blogSeoOverrides[slug]?.[locale] ?? null;
